exports = module.exports = require("../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".homeweb{width:100%}.homeweb .head{background-color:#f0f0f0;position:relative}.homeweb .main{margin:0 auto}", "", {"version":3,"sources":["/./src/components/web/WebHome.vue"],"names":[],"mappings":"AACA,SACE,UAAY,CACb,AACD,eACE,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,eACE,aAAe,CAChB","file":"WebHome.vue","sourcesContent":["\n.homeweb {\n  width: 100%;\n}\n.homeweb .head {\n  background-color: #f0f0f0;\n  position: relative;\n}\n.homeweb .main {\n  margin: 0 auto;\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.25.0@css-loader?sourceMap!./~/_vue-loader@9.9.5@vue-loader/lib/style-rewriter.js?id=data-v-7dfce6f4!./~/_stylus-loader@3.0.2@stylus-loader?sourceMap!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=styles&index=0!./src/components/web/WebHome.vue
// module id = 215
// module chunks = 0